import React, { JSX } from 'react';
import { SessionStorage } from '@ibe/services';
import ProductsSearchForm, { ListType, OnPackagesLoaded } from './ProductsSearchForm';
import { ApiProductCard } from '../../api';
import { ApiGetPackagesResponse } from '@ibe/api';
import { productSearchSessionKey } from '../Config/sessionkeys';

export type SessionStorageType = {
  search: string;
  list: ListType;
};

const sessionStorage = new SessionStorage<SessionStorageType>(productSearchSessionKey);

const isProductCards = (
  list: (ApiGetPackagesResponse | null) | ApiProductCard[]
): list is ApiProductCard[] => {
  return Array.isArray(list);
};

const Search = ({
  redirectUrl,
  sessionProp
}: {
  redirectUrl?: string;
  sessionProp?: SessionStorageType;
}): JSX.Element => {
  const handlePackagesLoaded: OnPackagesLoaded = (
    search: string,
    list: (ApiGetPackagesResponse | null) | ApiProductCard[]
  ): void => {
    if (
      (isProductCards(list) && list.length > 0) ||
      (!isProductCards(list) && !!list && list?.packages?.length > 0)
    ) {
      sessionStorage.set({ search, list });
      if (redirectUrl) {
        const url = new URL(redirectUrl, globalThis.location.href);
        url.searchParams.set('searchTerm', search);
        location.href = url.toString();
      }
    }
  };

  return (
    <ProductsSearchForm
      onPackagesLoaded={(
        search: string,
        list: (ApiGetPackagesResponse | null) | ApiProductCard[]
      ) => handlePackagesLoaded(search, list)}
      search={sessionProp?.search}
      updateUrlParam={!redirectUrl}
    />
  );
};

export default Search;
